import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { SignalRConnectionManagerService } from './core/services/signalr/signalr-connection-manager.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'WFG Identity Verification';

  constructor(private readonly signalRConnectionManager: SignalRConnectionManagerService) {}

  ngOnInit(): void {
    this.signalRConnectionManager.initialize();
  }
}
